import { Application, ApplicationStatusId } from "src/types/Application";
import { RiskLevelEnum } from "src/types/Applicant";
import { Configuration } from "src/types/Redux";
import { getRiskLevel } from "./Utils";

export function computeReadyToFinish(data: Application) {
  const applicationStatusId = data.applicationStatusId;
  const cancelled =
    data && applicationStatusId === ApplicationStatusId.Cancelled;

  const completed = data
    ? [
        ApplicationStatusId.LeaseSigned,
        ApplicationStatusId.LeaseExpired,
        ApplicationStatusId.LeaseDeclined,
      ].includes(applicationStatusId)
    : false;

  const readyToFinishCount = cancelled || completed ? 1 : 0;

  return readyToFinishCount;
}

/**
 * Check if an application has applicants with unresolved high-risk scores
 * @param application - The application to check
 * @param configuration - The configuration data containing risk level settings
 * @returns True if there are applicants with high-risk scores without clearance
 */
export function hasUnresolvedHighRisk(
  application: Application,
  configuration?: Configuration
): boolean {
  return (
    application?.applicants
      ?.filter((applicant) => !applicant.isSoftDelete)
      ?.some((applicant) => {
        // Check if applicant has a high risk score
        const hasHighRiskScore =
          configuration &&
          getRiskLevel(configuration, applicant.riskScore).risk ===
            RiskLevelEnum.HIGH;
        // Check if there's no valid exclusion clearance
        const noValidClearance = !applicant.exclusionListFurtherReviewClearedBy;
        return hasHighRiskScore && noValidClearance;
      }) ?? false
  );
}

export const getHighRiskApplicants = (
  application?: Application,
  configuration?: Configuration
) => {
  if (!application || !configuration) return [];
  return (
    application.applicants?.filter(
      (applicant) =>
        !applicant.isSoftDelete &&
        getRiskLevel(configuration, applicant.riskScore).risk ===
          RiskLevelEnum.HIGH &&
        !applicant.exclusionListFurtherReviewClearedBy
    ) || []
  );
};
